// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ywu5z","question":"styles_question__2bYDz","inputVisibleButton":"styles_inputVisibleButton__3QHEQ","note":"styles_note__ofeBI"};